<template>
  <transition name="fade">
    <div class="mobile-listing">
      <div class="container contentpages">
        <div class="mobile-section-title">Phone Cases</div>
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div class="row" v-else-if="pcovers && pcovers_sorted">
          <div class="col-md-12">
            <div class="sdata">
              <div class="text-center" v-for="index in Math.ceil(pcovers_sorted.length / logoPerRow)" v-bind:key="index">
                <div class="disInline" v-for="(item, key) in pcovers_sorted.slice(logoPerRow * (index - 1) + 1 - 1, logoPerRow * (index - 1) + logoPerRow)" v-bind:key="key">
                  <div v-if="item.cnt !== 0">
                    <div v-html="MOBILE_LOGO[item.category.toLowerCase()]" class="m-1 grow shadow-4 mobile-logo brand-cover" :class="(selectedBrand === logoPerRow * (index - 1) + key) && '_active'" @click="toggleListing($event, logoPerRow * (index - 1) + key)"></div>
                  </div>
                </div>
                <transition name="fade">
                  <div class="tooltips" v-bind:class="(isSelected && selectedBrand >= logoPerRow * (index - 1) + 1 - 1 && selectedBrand < logoPerRow * (index - 1) + logoPerRow) ? '_show': ''">
                    <div class="bottom">
                      <mobile-list :mobileList="pcovers_sorted[selectedBrand]" v-if="selectedBrand !== ''" ></mobile-list>
                      <i class="arrow"></i>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  import {metaElements} from '../assets/js/metaElements'
  import { MOBILE_LOGO } from '../assets/js/mobile-svgs.js'
  import Loader from './common/loader.vue'

  var mobileListing = {
    props: {
      mobileList: Object
    },
    template: `<ul class="cat-panel row" style="list-style: none; padding: 0; margin-bottom: 0;">
                <li class="model-cover col-6 col-md-6 col-xs-6 col-lg-3" v-for="(p, i) in mobileList.subcategories" :key="i">
                  <router-link :to="'/explore/' + p.url_key" style="color: #fff; font-size: 15px; margin: 10px; cursor: pointer;" onMouseOver="this.style.textDecoration='underline'" onMouseOut="this.style.textDecoration='none'">{{p.category}}</router-link>
                </li>
              </ul>`
  }
  export default {
    name: 'PhoneCovers',
    mixins: [metaElements],
    components: {
      Loader,
      'mobile-list': mobileListing
    },
    data () {
      return {
        pcovers: '',
        mobilecovers: {},
        MOBILE_LOGO: MOBILE_LOGO,
        isLoading: false,
        selectedBrand: '',
        previousSelected: '',
        isSelected: false,
        logoPerRow: 5,
        isDesktop: true,
        arrowPosition: 0,
        pcovers_sorted: ''
      }
    },
    methods: {
      getlist () {
        this.isLoading = true
        this.axios.get('https://api.thesouledstore.com/api/v1/listing/shop/mobile-covers').then((response) => {
          this.isLoading = false
          this.pcovers = response.data.covers
          this.pcovers_sorted = this.pcovers.filter(item => item.cnt !== 0)
          this.mobilecovers = response.data.mobileCovers
          // this.$parent.footerText = response.data.getPhcovers.footer_text
          this.metaTitle = response.data.metaTitle
          this.metaKeywords = response.data.metaKeys
          this.metaDescription = response.data.metaDesc
          this.ogTitle = response.data.metaTitle
          this.ogDescription = response.data.metaDesc
        })
      },
      toggleListing (event, index) {
        if (index !== this.previousSelected) {
          this.selectedBrand = index
          this.isSelected = true
          this.arrowPosition = this.isDesktop ? event.pageX - 150 : event.pageX
          this.arrowPosition = $(event.currentTarget).position().left + ($(event.currentTarget).width() / 2)
          $('.arrow').animate({ left: this.arrowPosition })
          this.previousSelected = index
        } else {
          this.selectedBrand = ''
          this.isSelected = false
          this.previousSelected = ''
        }
      }
    },
    created () {
      this.getlist()
      var b = $(window).width()

      if (b >= 1200) {
        this.isDesktop = true
      } else if (b < 1200 && b >= 480) {
        this.logoPerRow = 4
      } else {
        this.logoPerRow = 2
      }
    }
  }
</script>

<style lang="css">
  .mobile-listing .mobile-section-title {
    color: #545454;
    font-size: 25px;
    letter-spacing: 8px;
    text-align: center;
    text-transform: uppercase;
  }
  .mobile-listing .mobile-section-title:after {
    border-bottom: 2px solid #545454;
    content: " ";
    display: block;
    margin:0 auto;
    margin-top: 8px;
    position:relative;
    width: 86px;
  }
  .mobile-listing .coverslist {
    width: 20%;
  }
  .mobile-listing .tooltips {
    background-color: #818284;
    box-shadow: 0 1px 8px rgba(0,0,0,0.5);
    color: #fff;
    display: none;
    line-height: 25px;
    padding: 15px;
    position: relative;
    text-align:left;
    transition: all 2s linear;
    width: 100%;
  }
  .mobile-listing .tooltips._show {
    display: inline-block;
  }
  .mobile-listing .tooltips .bottom {
    background-color: #818284;
    color: #ffffff;
    font-size: 13px;
    font-weight: normal;
    padding: 0 20px;
  }
  .mobile-listing .tooltips .bottom .arrow {
    bottom: 100%;
    height: 12px;
    left: 50%;
    margin-left: -12px;
    overflow: hidden;
    position: absolute;
    width: 24px;
  }
  .mobile-listing .tooltips .bottom .arrow::after {
    background-color:#818284;
    box-shadow:0 1px 8px rgba(0,0,0,0.5);
    content:'';
    height:12px;
    left:50%;
    position:absolute;
    transform:translate(-50%,50%) rotate(45deg);
    width:12px;
  }
  .mobile-listing ul.cat-panel li.model-cover a {
    color: #fff;
    cursor: pointer;
    font-size: 15px;
    margin: 10px;
  }
  .mobile-listing ul.cat-panel li.model-cover a:hover {
    color: #fff;
    text-decoration: underline;
  }
  .mobile-listing .mobile-logo {
    cursor: pointer;
    height: 200px;
    transition: 0.3s;
    width: 200px;
    margin: 5px;
  }
  /* for mobile view only */
  @media only screen and (max-width: 768px) {
    .mobile-listing .mobile-logo {
      margin: 0;
    }
  }
  .grow {
    -moz-osx-font-smoothing: grayscale;
    backface-visibility: hidden;
    transform: translateZ(0);
    transition: transform 0.25s ease-out;
  }

  .grow:hover,
  .grow:focus {
    transform: scale(1.05);
  }

  .grow:active {
    transform: scale(.90);
  }

  .shadow-4 { box-shadow: 2px 2px 8px 0px rgba( 0, 0, 0, 0.2 ); }
 
  @media (--breakpoint-not-small) {
    .shadow-4-ns { box-shadow: 2px 2px 8px 0px rgba( 0, 0, 0, 0.2 ); }
  }

  @media (--breakpoint-medium) {
    .shadow-4-m { box-shadow: 2px 2px 8px 0px rgba( 0, 0, 0, 0.2 ); }
  }

  @media (--breakpoint-large) {
    .shadow-4-l { box-shadow: 2px 2px 8px 0px rgba( 0, 0, 0, 0.2 ); }
  }



  .mobile-listing .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .mobile-listing .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .mobile-listing svg .st0 {
    fill:#B9B9BB;
    transition: 0.3s;
  }
  .mobile-listing svg:hover .st0 {
    fill: #818284;
  }
  .mobile-listing ._active svg .st0 {
    fill: #818284;
  }

  @media screen and (max-width: 991px) {
    .mobile-listing .tooltips .bottom {
      min-width: 350px; 
    }
    .mobile-listing .coverslist {
      width: 33%;
    }
  }
  @media screen and (max-width: 450px) {
    .mobile-listing .coverslist {
      width: 50%;
    }
  }
  @media screen and (max-width: 480px) {
    .mobile-listing .mobile-logo {
      height: 130px;
      width: 130px;
    }
    .mobile-listing .tooltips .bottom {
      min-width: 175px;
      padding: 4px;
      top: 100px;
    }
    .mobile-listing .mobile-section-title {
      font-size: 20px;
      letter-spacing: 6px;
      padding-top: 15px;
    }
    .mobile-listing .mobile-section-title:after {
      margin-top: 3px;
    }
    .mobile-listing .coverslist ul.cat-panel li.model-cover a {
      margin: 4px;
    }
    .mobile-listing .tooltips {
      padding: 5px;
    }
  }

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// mobile-covers.vue?56a06680